module.exports = __webpack_public_path__ + "static/dev_central_homepage-5670c275fe9f3ab635c9aa81146169cf.png";